<template>
  <div class="contractManageList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="parkId" class="select">
            <el-option key :label="$t('lang.lab_pleParkName')" value=''></el-option>
            <el-option v-for="(item,index) in parks" :key="index" :label="item.parkName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="carNum" :placeholder="$t('lang.lab_pleCarNum')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="mobile" :placeholder="$t('lang.lab_preHouseholdNameOrPhone')"></el-input>
        </el-form-item>
        <el-form-item class="key-data">
          <el-date-picker v-model="inTimeSt" type="datetime" :placeholder="$t('lang.lab_InTime')+' >'" align="right"
            value-format="timestamp" :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="key-data">
          <el-date-picker v-model="inTimeEn" type="datetime" :placeholder="$t('lang.lab_InTime')+' <'" align="right"
            value-format="timestamp" :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="key-data">
          <el-date-picker v-model="outTimeSt" type="datetime" :placeholder="$t('lang.lab_OutTime')+' >'" align="right"
            value-format="timestamp" :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="key-data">
          <el-date-picker v-model="outTimeEn" type="datetime" :placeholder="$t('lang.lab_OutTime')+' <'" align="right"
            value-format="timestamp" :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
            <el-select v-model="state" :placeholder="$t('lang.resourStatus')">
              <el-option :label="$t('lang.resourWriteStatus')" value></el-option>
              <el-option :label="$t('lang.lab_In')" value = 1></el-option>
              <el-option :label="$t('lang.lab_Out')" value = 2></el-option>
            </el-select>
          </el-form-item>
        <el-button type="primary" @click="topics1">{{$t('lang.btn_search')}}</el-button>
       <el-form-item>
         <span>{{this.storeCount}}</span>
       </el-form-item>
      </el-form>
    </div>
    <el-card>
      <el-table :data="tableData" class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="teleInfosListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- 车场名称 -->
        <el-table-column prop="parkId" :label="$t('lang.lab_preHouseholdName')">
          <template slot-scope="scope" >
							<span v-if="scope.row.roomOwner">{{scope.row.roomOwner.name}}</span>
							<span v-else>
								{{$t('lang.lab_temporary')}}
							</span>
						</template>
        </el-table-column>
        <!-- 车牌号 -->
        <el-table-column prop="carNum" :label="$t('lang.lab_carNumber')"></el-table-column>
        <!-- 入场时间 -->
        <el-table-column prop="inTime" :label="$t('lang.lab_InTime')">
          <template slot-scope="scope">{{scope.row.inTime | time}}</template>
        </el-table-column>
        <!-- 出场时间 -->
        <el-table-column prop="outTime" :label="$t('lang.lab_OutTime')">
          <template slot-scope="scope">{{scope.row.outTime | time}}</template>
        </el-table-column>
        <!-- 停车时长 -->
        <el-table-column prop="inOutDeff" :label="$t('lang.lab_inOutDeff')">
          <template slot-scope="scope">{{scope.row.inOutDeff | formatInOutDeff}}</template>
        </el-table-column>
        <el-table-column prop="state" :label="$t('lang.resourStatus')">
          <template slot-scope="scope">
            <span v-if="scope.row.state === 1">{{$t('lang.lab_In')}}</span>
            <span v-if="scope.row.state === 2">{{$t('lang.lab_Out')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="inImagePath" :label="$t('lang.lab_inImagePath')">
          <template slot-scope="scope" v-if="scope.row.inImagePath!== null">
            <viewer :images="scope.row.inImagePath.split(',')" class="img-width">
              <img :src="scope.row.inImagePath" class="img">
            </viewer>
          </template>
        </el-table-column>
        <el-table-column prop="outImagePath" :label="$t('lang.lab_outImagePath')">
          <template slot-scope="scope" v-if="scope.row.outImagePath!== null && scope.row.state !== 1">
            <viewer :images="scope.row.outImagePath.split(',')" class="img-width">
              <img :src="scope.row.outImagePath" class="img">
            </viewer>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right"
          :width="require('@/config/enum').opr_width1">
          <template slot-scope="scope">
            <el-button @click="changeTel(scope.row.id)">{{$t('lang.btn_detail')}}</el-button>
          </template>
        </el-table-column>
        
      </el-table>
      <!-- 添加页码 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 添加弹框 -->
    <el-dialog :title="titleShow" :visible.sync="diaIsShow" :close-on-click-modal="false" center top="130px"
      width="800px" @closed="handleDialogClosed">
      <!-- 表单验证 -->
      <el-form ref="form" :model="form" :rules="rules" class="wid100" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('lang.lab_carNumber')">
              <span>{{ this.form.carNum }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('lang.resourStatus')">
              <span v-if="form.state === 1">{{$t('lang.lab_In')}}</span>
              <span v-if="form.state === 2">{{$t('lang.lab_Out')}}</span>
            </el-form-item>
          </el-col>
        </el-row> 
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('lang.lab_InTime')">
              <span>{{ this.form.inTime | time}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('lang.lab_OutTime')">
              <span>{{ this.form.outTime | time }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('lang.lab_inOutDeff')">
              <span>{{ this.form.inOutDeff | formatInOutDeff}}</span>
            </el-form-item>
          </el-col>
        </el-row>       
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:teleInfo
   *@Description:电话信息
   *@author:李斌
   *@Copyright:格众科技
   *@date:2020-03-13
   */
  import { mapGetters } from 'vuex'

  export default {
    name:'/manage/main.carInOutList',
    filters: {
      formatInOutDeff(value) {
        var theTime = parseInt(value) // 需要转换的时间秒 
        var theTime1 = 0 // 分 
        var theTime2 = 0 // 小时 
        var theTime3 = 0 // 天
        if (theTime > 60) {
          theTime1 = parseInt(theTime / 60)
          theTime = parseInt(theTime % 60)
          if (theTime1 > 60) {
            theTime2 = parseInt(theTime1 / 60)
            theTime1 = parseInt(theTime1 % 60)
            if (theTime2 > 24) {
              // 大于24小时
              theTime3 = parseInt(theTime2 / 24)
              theTime2 = parseInt(theTime2 % 24)
            }
          }
        }
        var result = ''
        if (theTime > 0) {
          result = '' + parseInt(theTime) + '秒'
        }
        if (theTime1 > 0) {
          result = '' + parseInt(theTime1) + '分' + result
        }
        if (theTime2 > 0) {
          result = '' + parseInt(theTime2) + '小时' + result
        }
        if (theTime3 > 0) {
          result = '' + parseInt(theTime3) + '天' + result
        }
        return result
      }
    },
    data() {
      return {
        isDisabled: true, // 按钮置灰
        saveData: '', // 存储json字符串
        name: '', // 名称
        content: '', // 电话
        serviceTime: '', // 服务时间
        editId: '', // 接收参数
        titleShow: '', // 弹框标题
        diaIsShow: false, // 弹框是否显示
        pageNum: 1, // 页数
        pageSize: 10, // 每页数量
        pageCount: 0, // 总页数
        tableData: [], // 表单数据
        multipleSelection: [], // 多选框
        type: '', // 判断checkbox的值
        storeCount: '',
        teleInfosListcheckbox: require('@/config/enum').teleInfosListcheckbox, // 是否隐藏复选框
        form: {
          
        },
        rules: {
          parkName: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleParkName'),
            trigger: 'blur'
          }],
          totalNum: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleCarTtotalNum'),
            trigger: 'blur'
          }]
        },
        parks: [], // 车场集合
        parkId: '',
        carNum: '',
        inTimeSt: '',
        inTimeEn: '',
        outTimeSt: '',
        outTimeEn: '',
        mobile: '',
        state: '1',
        pickerOptions1: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }]
        },
      }
    },
    // 初始化
    created() {
      this.getParks(this.gardenId)      
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    // 监听小区编号
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.topics()
      },
      form: {
        handler(newVal, oldVal) {
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      // 用户名只能输入数字
      keyBA() {
        // 仅保留数字和"."
        this.form.totalNum = this.form.totalNum.replace(/[^\d]/g, '')
        // 首位是0的话去掉
        if (this.form.totalNum.indexOf('.') < 0 && this.form.totalNum != '') {
          this.form.totalNum = parseFloat(this.form.totalNum)
        }
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 列表斑马线
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      topics() {
        let loading = this.$loading()
        if (this.inTimeSt == null) {
          this.inTimeSt = ''
        }
        if (this.inTimeEn == null) {
          this.inTimeEn = ''
        }
        if (this.outTimeSt == null) {
          this.outTimeSt = ''
        }
        if (this.outTimeEn == null) {
          this.outTimeEn = ''
        }
        this.$get(
          `/carInOut?gardenId=${this.gardenId}&parkId=${this.parkId}&carType=3&carNum=${this.carNum}&inTimeSt=${this.inTimeSt}&inTimeEn=${this.inTimeEn}&outTimeSt=${this.outTimeSt}&outTimeEn=${this.outTimeEn}&mobile=${this.mobile}&state=${this.state}&pageNo=${this.pageNum}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      storeCounts() {
          this.$get(
            `/carParkCountFix?gardenId=${this.gardenId}&parkId=${this.parkId}&carType=3`
          ).then(
          res => {
            if (res && res.errCode === 0) {
              this.storeCount = ' 固定车总车位数：' + res.mouthCount + ' 已入场：' + res.mouthUseCount + ' 剩余车位：' + res.mouthNoUseCount
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      topics1() {
        this.pageNum = 1
        let loading = this.$loading()
        if (this.inTimeSt == null) {
          this.inTimeSt = ''
        }
        if (this.inTimeEn == null) {
          this.inTimeEn = ''
        }
        if (this.outTimeSt == null) {
          this.outTimeSt = ''
        }
        if (this.outTimeEn == null) {
          this.outTimeEn = ''
        }
        this.$get(
          `/carInOut?gardenId=${this.gardenId}&parkId=${this.parkId}&carType=3&carNum=${this.carNum}&inTimeSt=${this.inTimeSt}&inTimeEn=${this.inTimeEn}&outTimeSt=${this.outTimeSt}&outTimeEn=${this.outTimeEn}&mobile=${this.mobile}&state=${this.state}&pageNo=1&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
              this.storeCounts()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取车场List
      getParks(val) {
        this.$get(`carPark?pageNo=1&pageSize=999&gardenId=` + val).then(
          res => {
            if (res && res.errCode === 0) {
              this.parks = res.list
              if (res.list.length > 0) {
								this.parkId = res.list[0].id
                this.topics()
                this.storeCounts()
							}
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 添加电话
      addTel() {
        this.editId = ''
        this.titleShow = this.$i18n.t('lang.lab_addPark')
        this.form.parkName = ''
        this.form.totalNum = ''
        this.form.isRepeat = '1'
        this.diaIsShow = true
      },
      // 修改电话信息
      changeTel(id) {
        this.getData(id)
        this.titleShow = this.$i18n.t('lang.btn_detail')
        this.diaIsShow = true
      },
       // id查询详情
    getData(id) {
      let loading = this.$loading()
      this.$get(`/carInOut/` + id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            console.log(res)
            this.form = res.carInOut
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
      addPlace(id) {
        this.$router.push({
          path: '/manage/carPlaceList',
          query: {
            id: id
          }
        })
      },
      addGate(id) {
        this.$router.push({
          path: '/manage/carGateList',
          query: {
            id: id
          }
        })
      },
      // 删除
      delTele(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            this.$delete(`carPark/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.topics()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 保存
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.editId === '') {
              let params = {
                gardenId: this.gardenId,
                parkName: this.form.parkName,
                totalNum: this.form.totalNum,
                isRepeat: this.form.isRepeat
              }
              if (this.gardenId === 0) {
                this.$message.error(this.$i18n.t('lang.reportPleaseSelectVillage'))
                return
              }
              let loading = this.$loading()
              this.$post(`/carPark/`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.topics()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              let loading = this.$loading()
              let params = {
                parkName: this.form.parkName,
                totalNum: this.form.totalNum,
                isRepeat: this.form.isRepeat
              }
              this.$patch(`/carPark/${this.editId}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.topics()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
              console.log(params.type)
            }
          }
        })
      },
      clear() {
        this.$refs.form.resetFields()
        this.form.parkName = ''
        this.form.totalNum = ''
        this.form.isRepeat = '1'
      },
      // 监听关闭dialog
      handleDialogClosed() {
        this.clear()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.topics()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.topics()
      }
    }
  }
</script>

<style lang="scss">
  .img {
      width: 60px;
      height: 40px;
      border: 1px solid lightgray;
      border-radius: 5px;
      padding: 5px;
    }
    .img-width {
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
      max-width: 320px;
    }
  .contractManageList {
    .detp-type {
      .el-form-item__content {
        width: 100%;

        .el-select {
          width: 315px;

          .el-input__inner {
            min-width: 100px;
          }
        }
      }
    }

    .el-collapse-item__header {
      font-size: 16px;
      padding-left: 0%;
      margin-left: 0px;
      border-bottom: 0px;
    }

    .el-collapse {
      border-top: 0px;
    }

    .el-collapse-item__wrap {
      will-change: height;
      background-color: #FFF;
      overflow: hidden;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-bottom: 0px solid #EBEEF5;
    }

    .key-input {
      width: 30%;

      .el-form-item__content {
        width: 100%;

        .el-input__inner {
          min-width: 100px;
        }
      }
    }

    .key-data {
      .el-date-editor {

        &.el-input,
        .el-input__inner {
          width: 200px;
        }

        .el-range-separator {
          height: 28px;
          line-height: 28px;
        }
      }
    }

    .selee {
      width: 28%;

      .el-form-item__content {
        width: 100%;
        min-width: 180px;

        .el-select {
          width: 100%;
          min-width: 180px;

          .el-input--suffix {
            min-width: 180px;
          }
        }
      }
    }

    .key-dept {
      width: 50%;

      .el-form-item__content {
        width: 100%;

        .el-select {
          width: 100%;
        }
      }

    }

    .red {
      color: red;
    }
  }
</style>